import { select } from "redux-saga/effects";

import { history } from "state/history";
import { getNoticeByID } from "state/teachers/selectors";

export default function* goToNoticeSaga(action) {
  const { noticeID } = action.payload;
  const notice = yield select(getNoticeByID, noticeID);
  const { schoolID } = notice.toObject();
  history.push(`/teachers/noticeboard/${schoolID}/`);
}



// WEBPACK FOOTER //
// ./src/state/teachers/sagas/goToNoticeSaga.js